module.exports = __webpack_public_path__ + "static/media/morph_run.2369b81a.jpg";